'use strict';
/* COMPONENT - c.06.09 - Shop details */

import ShopMap from './c06.01_shop-map.js';

class ShopDetails extends ShopMap {
    constructor(element) {
        super(element);
        this.link = this.root.querySelector('.shop-details-directions').getElementsByTagName('a')[0];
        this.coords = this.root.querySelector('.shop-map-link').getAttribute('data-coords');
    }
}

export default ShopDetails;
